"use client";
import "react-multi-carousel/lib/styles.css";
import Carousel from "react-multi-carousel";
import { ResponsiveType } from "react-multi-carousel";
import React from "react";
import BannerAds from "../banner-ads/banner-ads";
// import CustomRightArrow from '../right-arrow/right-arrow';
import CardMovie from "../card-movie/card-movie";
import { IMovie } from "@/interfaces/movie";
import TitleCommon from "../title-common/title-common";
import BannerAdsSmall from "../banner-ads/banner-ads-small";
import BannerVips from "../banner-ads/banner-vips";

function CarouselBooks({ movies }: { movies: IMovie[] }) {
  const responsive: ResponsiveType = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 6,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };
  return (
    <div className="">
      <h1 className="uppercase text-white mb-2 text-[24px] max-lg:text-[18px] max-md:text-[16px] font-medium">
        Phim mới mỗi ngày
      </h1>
      <Carousel responsive={responsive} arrows itemClass="px-2">
        {movies.map((val, index) => {
          return (
            <div key={index} className="h-full">
              <CardMovie data={val} />
            </div>
          );
        })}
      </Carousel>
      <BannerAds />
      <BannerAdsSmall />
    </div>
  );
}

export default CarouselBooks;
